import { defineNuxtPlugin } from '#imports'
import { MIXPANEL_KEY } from '@/app/utils/constant'
import { mixpanelAnalytics } from '@/app/providers/mixPanel/BaseTracker'

export default defineNuxtPlugin(() => {
  if (MIXPANEL_KEY) {
    mixpanelAnalytics.init()
  }
})
